import { useIntl } from 'react-intl'
import {
  FilterFooter,
  FilterListbox,
  FilterOptionRadio,
  FilterPopover,
  type UseFilterStateReturn,
} from '@vtex/admin-ui'
import { BaseFilter } from '@/components/filters/BaseFilter/BaseFilter'
import { useFilter } from '@/components/filters/hooks/useFilter'

interface FilterVisibleProps<T> {
  state: UseFilterStateReturn<T>
}

function FilterVisiblePopover<T = boolean>(props: FilterVisibleProps<T>) {
  const { state } = props

  const { formatMessage } = useIntl()

  return (
    <FilterPopover state={state}>
      <FilterListbox>
        <FilterOptionRadio
          id="visible"
          value={true}
          label={formatMessage({
            id: 'admin/admin.catalog.visible-filter-option-label',
            defaultMessage: 'Visible on store',
          })}
        />
        <FilterOptionRadio
          id="not-visible"
          value={false}
          label={formatMessage({
            id: 'admin/admin.catalog.not-visible-filter-option-label',
            defaultMessage: 'Not visible on store',
          })}
        />
      </FilterListbox>
      <FilterFooter />
    </FilterPopover>
  )
}

export type SerializedData = '' | 'true' | 'false'

export function FilterVisible(props: { name: string }) {
  const { formatMessage } = useIntl()

  return (
    <BaseFilter
      disclosureMessage={formatMessage({
        id: 'admin/admin.catalog.visible-filter-label',
        defaultMessage: 'Store Visibility',
      })}
      FilterPopoverComponent={FilterVisiblePopover}
      filterName={props.name}
      useFilterState={useFilter}
      toSerializableData={(data) =>
        String(data.appliedItem?.value ?? '') as SerializedData
      }
    />
  )
}
